import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import { Loading } from './utility/Utility';

function isViewerBlockedPath(pathname) {
  if (!pathname.startsWith('/app')) return false;
  if (pathname.includes('/reporting')) return false;
  if (/^\/app\/promotions\/[^/]+/.test(pathname)) return true;
  if (/^\/app\/giveaways\/[^/]+/.test(pathname)) return true;
  if (pathname === '/app/onboarding') return false;
  return false;
}

export default function AuthorizedRoute({ children, ownerOnly = false }) {
  const { authed, authReady, userProfile, membershipRole, needsStoreOnboarding } =
    useContext(AuthContext);
  const location = useLocation();

  const LoadingWithLayout = () => (
    <div className="main">
      <Loading />
    </div>
  );

  // Wait for session restore / token refresh before sending users to login.
  if (!authReady) {
    return <LoadingWithLayout />;
  }

  if (!authed) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!userProfile) {
    return <LoadingWithLayout />;
  }

  if (needsStoreOnboarding && location.pathname !== '/app/store-setup') {
    return <Navigate to="/app/store-setup" replace />;
  }

  if (ownerOnly && membershipRole !== 'owner') {
    return <Navigate to="/app/settings" replace />;
  }

  if (membershipRole === 'viewer' && isViewerBlockedPath(location.pathname)) {
    const listPath = location.pathname.includes('/promotions')
      ? '/app/loyalty/promotions'
      : location.pathname.includes('/giveaways')
        ? '/app/loyalty/giveaways'
        : '/app/product-analysis/analytics';
    return <Navigate to={listPath} replace />;
  }

  return children;
}
